import React from 'react'
import PropTypes from 'prop-types'
import WizardRedux from 'common/pkgs/WizardRedux'

const RegistrationPage = ({
    submitActionType,
    submitPayload,
}) => (
    <WizardRedux.Wrapper
        submitActionType={submitActionType}
        submitPayload={submitPayload}
        id="RegistrationWizard"
    >
        <WizardRedux.StepRoute
            url="/login"
            as="/login"
        />
    </WizardRedux.Wrapper>
)

RegistrationPage.propTypes = {
    submitActionType: PropTypes.string.isRequired,
    submitPayload: PropTypes.object.isRequired,
}

export default RegistrationPage
